export default [
  {
    firstColor: '#6846e3',
    secondColor: '#ff5d5e'
  }, {
    firstColor: '#20a4e6',
    secondColor: '#d15dff'
  }, {
    firstColor: '#2e469d',
    secondColor: '#1cebf5'
  }, {
    firstColor: '#d62058',
    secondColor: '#f9a83c'
  }, {
    firstColor: '#69d9ff',
    secondColor: '#985eff'
  }, {
    firstColor: '#e1207b',
    secondColor: '#6f2d8a'
  }, {
    firstColor: '#199843',
    secondColor: '#f5eb23'
  }
]



// WEBPACK FOOTER //
// ./src/constants/gradients.js